/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { infoFilled } from "../assets/info-filled";
import { Icon, type IconBaseProps } from "../icon";

export const IconInfoFilled = (props: IconBaseProps) => <Icon {...props} svg={infoFilled} />;

IconInfoFilled.displayName = "IconInfoFilled";
